/**
 * Generated runtime TestId mirror for frontend/src/components/inbound-connectors/ResponseFiltersEditor.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ResponseFiltersEditorTestIds = {
  btnAddResponseFilter: "btn-add-response-filter",
  responseFilters: "response-filters",
  responseFilterField: (index: number) => `response-filter-field-${index}`,
  responseFilterFieldPrefix: () => "response-filter-field-" as TestIdPrefix,
  responseFilterRemove: (index: number) => `response-filter-remove-${index}`,
  responseFilterRemovePrefix: () => "response-filter-remove-" as TestIdPrefix,
  responseFilterValue: (index: number) => `response-filter-value-${index}`,
  responseFilterValuePrefix: () => "response-filter-value-" as TestIdPrefix
} as const;
